/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

import CaseActionsArchiveButton from './CaseActionsArchiveButton';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles(() => {
  return {
    sectionHeader: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    sectionText: {
      color: '#999999',
      fontSize: '12px',
      marginTop: '1rem',
    },
  };
});

export default ({ onCaseAction, auth, isArchiving$, isArchiving }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" style={{ textAlign: 'left' }}>
      <Grid item container>
        <Grid item>
          <Typography className={classes.sectionHeader}>Claim Case</Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.sectionText}>
            By clicking the below button you will claim the case and be presented with a video recorder to create a full report on this matter. <br />
            <br />
            If at any point you are not comfortable with completing this report you will have the option to opt out at any point before completion.
          </Typography>
        </Grid>
      </Grid>
      <Grid item style={{ marginTop: '1rem' }}>
        <Grid container spacing={1}>
          <Grid item>
            <LoadingButton disabled={isArchiving} color="primary" variant="contained" size="large" onClick={() => onCaseAction('claim')}>
              Claim Case
            </LoadingButton>
          </Grid>
          <Grid item>
            <CaseActionsArchiveButton auth={auth} isArchiving$={isArchiving$} onCaseAction={onCaseAction} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
